let shellContentScrollElement = null

export const setShellContentScrollElement = (element) => {
  shellContentScrollElement = element
}

export const getShellContentScrollElement = () => shellContentScrollElement
